import React from 'react';
import Configurator from './Configurator.jsx';
import styles from "./OniEquipmentConfigurator.styl";
import jQuery from "jquery";
import ReCAPTCHA from "react-google-recaptcha";


/**
 * Конфигуратор оборудования ONI
 */
class OniEquipmentConfigurator extends Configurator
{
	constructor(props) {
		super(props);

		this.state = {
			equipmentType: '', // oni_equipment_hmi
			equipmentTypeObj: {},
			equipmentTypes: [],
			items: [],
			filters: {},
			currentFilter: {},
			infoItem: null,
			cart: [],
			page: 'start', // info, cart
			action:'equipment', //equipment, analog
			searchTab: 'handSearch', //handSearch, listSearch
			analogList:[],
			analogItems:[],
			analogOniItems:[],
			analogBrand:'Все',
			brandCollection:[]
		};

		this.onChangeEquipmentType = this.onChangeEquipmentType.bind(this);
		this.onFilter              = this.onFilter.bind(this);
		this.onFilterReset         = this.onFilterReset.bind(this);
		this.showInfo              = this.showInfo.bind(this);
		this.onAddToCart           = this.onAddToCart.bind(this);
		this.onDelete           		= this.onDelete.bind(this);
		this.onMyOrdersExport      = this.onMyOrdersExport.bind(this);
		this.onMyOrdersChangeQuantity = this.onMyOrdersChangeQuantity.bind(this);
		this.onProductExport = this.onProductExport.bind(this);
		this.analogChosen = this.analogChosen.bind(this);
		this.equipmentChosen = this.equipmentChosen.bind(this);
		this.analogSearchHandle = this.analogSearchHandle.bind(this)
		this.analogBrandSearch = this.analogBrandSearch.bind(this)
		this.generateBrandCollection = this.generateBrandCollection.bind(this)
		this.addAnalogOni = this.addAnalogOni.bind(this)
		this.handSearchChosen = this.handSearchChosen.bind(this)
		this.listSearchChosen = this.listSearchChosen.bind(this)
		this.analogListSearchHandle = this.analogListSearchHandle.bind(this)
	}

	getType() {
		return 'oni_equipment';
	}

	getCustomStyles() {
		return styles;
	}

	loadDb() {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'get'
			},
			db => {
				this.db = db;
				this.onChangeEquipmentType('oni_equipment_hmi');
				this.setState({analogList: db.list.oni_analog, analogItems:db.list.oni_analog},()=>{this.generateBrandCollection()})
			}
		);
	}

	onChangeEquipmentType(equipmentType) {

		let list_reserve = []

		if (equipmentType === 'oni_equipment_reserve') {
			this.db.list.oni_equipment_reserve.map(item => {
				if (!list_reserve.some(i => i.name === item.groups_name && i.voltage === item.voltage)) {
					list_reserve.push({
						article: item.article_group,
						name: item.groups_name,
						list: [],
						voltage: item.voltage,
						groups: item.groups,
						grouping: item.grouping,
						auto_switch: item.auto_switch,
						power_sources: item.power_sources,
						apply_options: [],
						WiringDiagram:[{
							name: item.groups_name,
							file_ref:{
								uri: `itkcfg.php?action=getFileZip&type=oni_equipment&name=reserve&article=${item.article_group}`
							}
						}]
					})
				}
				list_reserve.find(i => i.name === item.groups_name && i.voltage === item.voltage).list.push(item)
			})

			list_reserve = list_reserve.map(item => {
				 item.list.map(i => {
					if(item.apply_options.indexOf(i.apply_options) === -1) item.apply_options.push(i.apply_options)
					return i
				})
				item.printList = item.list.filter(i => i.apply_options === '')
				return item
			})

		}

		this.setState({
			equipmentType,
			equipmentTypeObj: this.db.equipment_types.find(eq => eq.type === equipmentType),
			items: this.db.list[equipmentType],
			list_reserve: list_reserve,
			items_reserve:list_reserve,
			filters: this.db.filter[equipmentType],
			filters_names: this.db.filter_names[equipmentType],
			filter_common_article: this.db.filter_common_article[equipmentType],
			filter_pumping_article: this.db.filter_pumping_article[equipmentType],
			filter_starter_article: this.db.filter_starter_article[equipmentType],
			filter_power_article: this.db.filter_power_article[equipmentType],
			equipmentTypes: this.db.equipment_types,
			currentFilter: {}
		});
	}

	onFilter(prop, value) {
		this.setState(prevState => {
			const currentFilter = jQuery.extend({}, prevState.currentFilter);
			const list = this.db.list[prevState.equipmentType]
			const list_reserve = this.state.list_reserve
			const filters = {};
			if (value === '') {
				delete currentFilter[prop];
			} else {
				currentFilter[prop] = value;
			}

			if(prevState.equipmentType === 'oni_equipment_reserve') {

				const items_reserve = list_reserve.filter(item => {
					for (const filterProp in currentFilter) {
						if (currentFilter.hasOwnProperty(filterProp)){
							if(item[filterProp] !== currentFilter[filterProp] && filterProp !== 'apply_options') return false
						}
					}
					return true
				}).map(item => {
					if(!currentFilter.apply_options) {
						item.printList = item.list.filter(i => i.apply_options === '')
						return item
					}
					item.printList = item.list.filter(i => i.apply_options === '' || i.apply_options === currentFilter.apply_options)
					return item
				});

				const apply_options = items_reserve.reduce((options, item) => {
					item.apply_options.map(i => {
						if(options.indexOf(i) === -1) options.push(i)
					})
					return options
				},[]).sort();

				const filters =  {
					grouping:["Да", "Нет"],
					groups: ["1", "2"],
					power_sources:["1", "2"],
					voltage:["24 VDC", "220 VAC"],
					apply_options: apply_options,
					auto_switch:["Да", "Нет"]
				};
				return {
					items: [],
					currentFilter,
					items_reserve,
					filters
				}
			}

			const items = list.filter(item => {
				for (const filterProp in currentFilter)
				{
					if (!currentFilter.hasOwnProperty(filterProp)) {
						continue;
					}

					if (Array.isArray(item[filterProp]) ? item[filterProp].indexOf(currentFilter[filterProp]) < 0 : item[filterProp] !== currentFilter[filterProp])
					{
						let otherMatch = true;

						for (const _filterProp in currentFilter)
						{
							if (!currentFilter.hasOwnProperty(_filterProp) || (_filterProp === filterProp)) {
								continue;
							}

							if (Array.isArray(item[_filterProp]) ? item[_filterProp].indexOf(currentFilter[_filterProp]) < 0 : item[_filterProp] !== currentFilter[_filterProp]) {
								otherMatch = false;
								break;
							}
						}

						if (otherMatch)
						{
							if (!(filterProp in filters)) {
								filters[filterProp] = [];
							}

							if (Array.isArray(item[filterProp]))
							{
								for (let i = 0; i < item[filterProp].length; i++)
								{
									if (filters[filterProp].indexOf(item[filterProp][i]) === -1 && item[filterProp][i] !== '') {
										filters[filterProp].push(item[filterProp][i]);
									}
								}
							}
							else
							{
								if (filters[filterProp].indexOf(item[filterProp]) === -1 && item[filterProp] !== '') {
									filters[filterProp].push(item[filterProp]);
								}
							}
						}

						return false;
					}
				}

				for (const itemProp in item)
				{
					if (!item.hasOwnProperty(itemProp) || !(itemProp in this.db.filter[prevState.equipmentType])) {
						continue;
					}

					if (!(itemProp in filters)) {
						filters[itemProp] = [];
					}

					if (Array.isArray(item[itemProp]))
					{
						for (let i = 0; i < item[itemProp].length; i++)
						{
							if (filters[itemProp].indexOf(item[itemProp][i]) >= 0 || item[itemProp][i] === '') {
								continue;
							}

							filters[itemProp].push(item[itemProp][i]);
						}
					}
					else
					{
						if (filters[itemProp].indexOf(item[itemProp]) >= 0 || item[itemProp] === '') {
							continue;
						}

						filters[itemProp].push(item[itemProp]);
					}
				}

				return true;
			});

			for (const filterProp in filters)
			{
				if (!filters.hasOwnProperty(filterProp) || (filters[filterProp].length === 0)) {
					continue;
				}

				filters[filterProp].sort((a, b) => {
					return (this.db.filter[prevState.equipmentType][filterProp].indexOf(a) >
						this.db.filter[prevState.equipmentType][filterProp].indexOf(b) ? 1 : -1);
				});
			}

			return {
				currentFilter,
				filters,
				items
			};
		});
	}

	onFilterReset() {
		this.onChangeEquipmentType(this.state.equipmentType);
	}

	onAddToCart(item) {

		const addToCard = item =>  {
			this.setState(prevState => {
				const cart = [...prevState.cart];
				const _item = item ? item : prevState.infoItem;

				for (let i = 0; i < cart.length; i++)
				{

					if (cart[i].article === _item.article) {

						if(cart[i].count_equipment) {

							cart[i].quantity += +cart[i].count_equipment

							return {
								cart
							};

						}
						cart[i].quantity++;
						return {
							cart
						};
					}
				}
				if(_item.count_equipment) {
					let number = +_item.count_equipment
					if(isNaN(+_item.count_equipment)) {
						number = +_item.count_equipment.replace(',', '.')
					}
					cart.push(jQuery.extend({quantity: number}, _item));
				} else {
					cart.push(jQuery.extend({quantity: 1}, _item));

				}
				return {
					cart
				};
			},()=>{
				this.doAddToCart(this.state.cart)
			});
		}

		if(item.printList) {
			item.printList.map(i => addToCard(i))
			return
		}

		addToCard(item)


	}
	doAddToCart(items){
		const goods = JSON.stringify(
			{
				products: items.map(i => (
					{
						cnt: i.quantity || 1,
						art: i.article || i.art,
						name: i.name,
					}
				))
			}
		)
		console.log(goods);
		// Отправка JSON в ipro
		window.top.postMessage(goods, '*')
	}
	onDelete(item) {
		this.setState(prevState => {
			const cart = [...prevState.cart];
			let newCart = cart
			if(confirm('Удалить позицию?')) {
				newCart = cart.filter(i => i.article !== item.article)
			}
			return {cart: newCart};
		},()=>{
			this.doAddToCart(this.state.cart)
		});
	}

	showInfo(infoItem) {
		this.setState({
			infoItem,
			page: 'info'
		});
	}

	 doPrint(params) {
		let _params = params || {};

		_params.data = {
			speclist: JSON.stringify(this.state.cart),
			infoItem: JSON.stringify(this.state.infoItem),
			productInfo: JSON.stringify(params.productInfo),
			page: this.state.page
		}
		super.doPrint(_params);
	}

	onMyOrdersExport(format) {
		this.doPrint({format});
	}

	onMyOrdersChangeQuantity(item, quantity) {
		this.setState(prevState => {
			const cart = JSON.parse(JSON.stringify(prevState.cart));

			for (let i = 0; i < cart.length; i++)
			{
				if (cart[i].article === item.article) {
					cart[i].quantity = quantity;
					break;
				}
			}

			return {
				cart
			};
		},()=>{
			this.doAddToCart(this.state.cart)
		});
	}

	onProductExport(productInfo, format) {
		this.doPrint({format, productInfo});
	}
	equipmentChosen(){
		if(this.state.action==='equipment'){
			return
		}
		this.setState({
			action: 'equipment'
		})
	}
	analogChosen(){
		if(this.state.action==='analog'){
			return
		}
		this.setState({
			action: 'analog'
		})
	}
	analogSearchHandle (e) {
		let value=e
		let items =[]
		if(this.state.analogBrand==='Все'){
			items=this.state.analogList.filter(item =>
			item.name.toLowerCase().includes(value.toLowerCase())
			|| item.article.toLowerCase().includes(value.toLowerCase()))
		}else {
			let collection=this.state.analogList.filter(item => item.brand.toLowerCase().includes(this.state.analogBrand.toLowerCase()))
			items=collection.filter(item =>
				item.name.toLowerCase().includes(value.toLowerCase())
				|| item.article.toLowerCase().includes(value.toLowerCase()))

		}

		this.setState(prev=>{
			return{ analogItems:items}
		})
	}
	analogListSearchHandle (e) {
		let value=e.split(' ')
		let items =[]
		if(value[value.length-1]!=='') {
			value.map(item => {
				let x = this.state.analogList.filter(i =>
					i.article.toLowerCase().includes(item.toLowerCase()))
				items = items.concat(x)

			})


			this.setState(prev => {
				return {analogItems: items}
			})
		}
	}

	analogBrandSearch(e){
		let value=e
		let items =[]
		items=this.state.analogList.filter(item => item.brand.toLowerCase().includes(value.toLowerCase()))
		if(value==='Все'){
			items=this.state.analogList
		}
		this.setState(()=>{return{analogItems:items, analogBrand:value}})
	}
	 generateBrandCollection (){
		 let collection=[]
		 this.state.analogList.forEach(i=>{
			 if(i.brand && !collection.includes(i.brand)){
				 collection.push(i.brand)
			 }}
		 )
		 this.setState({brandCollection: collection})
}
	addAnalogOni(article){
	let collection=[]
		let items= this.db.list['oni_analog_list']
		if(article){
			let analogArticles=article.split(',')
			analogArticles.forEach(i=>{
				items.map(item=>{
					if(item.article.trim()===i.trim()){
						collection.push(item)
					}
				})
			})
		}
		this.setState(()=>{return{analogOniItems:collection}})
	}
	 handSearchChosen(){
		 if(this.state.searchTab==='handSearch'){
			 return
		 }
		 this.setState({
			 searchTab: 'handSearch'
		 })
	 }
	listSearchChosen(){
		if(this.state.searchTab==='listSearch'){
			return
		}
		this.setState({
			searchTab: 'listSearch'
		})
	}

	render() {
		if (!this.db) {
			return <div className={styles.cfg} />;
		}
		let firstLableStyle = ''
		let secondLableStyle = ''
		let firstTextStyle = ''
		let secondTextStyle = ''
		let firstLStyle = ''
		let secondLStyle = ''
		let firstTStyle=''
		let secondTStyle=''
		let shadowStyleFirst=''
		let shadowStyleSecond=''
		let shadowStlFirst=''
		let shadowStlSecond=''

		if(this.state.action === 'analog'){
			firstLableStyle = '#e3e3e3'
			secondLableStyle = '#29318c'
			firstTextStyle='#4d4d4d'
			secondTextStyle='#fff'
			shadowStlFirst='none'
			shadowStlSecond='0 3px 5px rgba(0,0,0,0.5)'
		}else if(this.state.action === 'equipment'){
			firstLableStyle = '#29318c'
			secondLableStyle = '#e3e3e3'
			firstTextStyle='#fff'
			secondTextStyle='#4d4d4d'
			shadowStlFirst='0 3px 5px rgba(0,0,0,0.5)'
			shadowStlSecond='none'
		}
		if(this.state.searchTab ==='listSearch'){
			firstLStyle = '#e3e3e3'
			secondLStyle = '#fff'
			firstTStyle='#4d4d4d'
			secondTStyle='#000'
			shadowStyleFirst='none'
			shadowStyleSecond='0 2px 3px rgba(0,0,0,0.5)'
		}else if(this.state.searchTab === 'handSearch'){
			firstLStyle = '#fff'
			secondLStyle = '#e3e3e3'
			firstTStyle='#000'
			secondTStyle='#4d4d4d'
			shadowStyleFirst='0 2px 3px rgba(0,0,0,0.5)'
			shadowStyleSecond='none'
		}

		return (
			<div className={styles.cfg}>
				<div className="row">

					<div className="col-md-3">

						<div className={styles.backToStartPage} onClick={() => this.setState({page: 'start'})}>
							{this.state.page === 'start' ?
								(
									<div className={styles.backToStartPageFirst}>Конфигуратор подбора оборудования</div>
								) : (
									<div>
										<div className={styles.backToStartPageFirst}>Вернуться назад</div>
										<div className={styles.backToStartPageSecond}>к Выбору оборудования</div>
									</div>
								)
							}
						</div>

						<div className={styles.myOrders} onClick={() => this.setState({page: 'cart'})}>Мои заказы <span className="badge">{this.state.cart.length}</span></div>
						<a style={{position:'absolute', color: '#333',paddingTop:'12px'}} href={'https://oni-system.com/podderzhka/'} target={'_blank'}>Техническая поддержка</a>
					</div>

					<div className="col-md-9">

						{this.state.page === 'info' && this.state.infoItem &&
							<ProductInfo
								item={this.state.infoItem}
								onClose={() => this.setState({ infoItem: null })}
								onAddToCart={this.onAddToCart}
								onExport={this.onProductExport}
								equipmentType={this.state.equipmentType}
							/>
						}

						{this.state.page === 'start' && this.state.action=== 'equipment' &&
							<div>

								<div className="row form-group">
									<div className='container-fluid form-group'>
						      <div
										onClick={this.equipmentChosen}
										style={{background: firstLableStyle,color: firstTextStyle, cursor:'pointer',height:'40px', paddingTop:'5px', fontSize: '16px', boxShadow: shadowStlFirst}}
										className=' col-md-6 text-nowrap text-center'>Конфигуратор подбора оборудования</div>
										<div
											onClick={this.analogChosen}
											style={{background: secondLableStyle, color: secondTextStyle, cursor:'pointer',height:'40px', paddingTop:'5px', fontSize: '16px', boxShadow: shadowStlSecond}}
											className='col-md-6 text-nowrap text-center'>Подбор аналогов сторонних производителей</div>
									</div>

									<div className="col-md-2 text-nowrap text-left">
										<div style={{padding: "4px 0"}}>Тип оборудования</div>
									</div>

									<div className="col-md-10">
										<select className="col-md-5" value={this.state.equipmentType} onChange={e => this.onChangeEquipmentType(e.target.value)}>
											{this.state.equipmentTypes.map(type =>
												<option key={type.type} value={type.type}>{type.name}</option>
											)}
										</select>
									</div>
								</div>

								<Filter db={this.db} state={this.state} onFilter={this.onFilter} onReset={this.onFilterReset} />

								{this.state.equipmentType !== 'oni_equipment_reserve' && <div className={styles.itemsTableWrap}>
									<table className={styles.itemsTable}>
										<thead>
											<tr>
												<th>Артикул</th>
												<th>Наименование</th>
												<th>&nbsp;</th>
												<th>&nbsp;</th>
											</tr>
										</thead>
										<tbody>
											{this.state.items.map(item =>
												<tr key={item.article}>
													<td className="col-md-3 text-nowrap">{item.article}</td>
													<td>{item.name}</td>
													<td><span className={styles.itemInfo} onClick={() => this.showInfo(item)}><span className="glyphicon glyphicon-info-sign" /></span></td>
													<td className={styles.itemAddToCartBtn}>
														<span className={styles.itemAddToCart} onClick={() => this.onAddToCart(item)}>
															<span className={`glyphicon glyphicon-shopping-cart`} />
														</span>
													</td>
												</tr>
											)}
										</tbody>
									</table>
								</div>}

								{this.state.equipmentType === 'oni_equipment_reserve' && <React.Fragment>
									<div className={styles.itemsTableWrapReserve}>
										<table className={styles.itemsTable}>
											<thead>
											<tr>
												<th>Наименование</th>
												<th>&nbsp;</th>
												<th>&nbsp;</th>
											</tr>
											</thead>
											<tbody>
											{this.state.items_reserve.map((item,index) =>
												<tr key={index}>
													<td>{item.name}</td>
													<td><span className={styles.itemInfo} onClick={() => this.showInfo(item)}><span className="glyphicon glyphicon-info-sign" /></span></td>
													<td  className={styles.itemAddToCartBtn}><span className={styles.itemAddToCart} onClick={() => this.onAddToCart(item)}><span className={`glyphicon glyphicon-shopping-cart`} /></span></td>
												</tr>
											)}
											</tbody>
										</table>
									</div>
									<div className="row">
										<p style={{fontSize: '10px', fontWeight: 'bold'}} className="col-md-12">
										№1 - обеспечивает индикацию состояния АВР и коммутирующих аппаратов с помощью индикаторных ламп и обеспечивает возможность ручного дистанционного управления коммутирующими аппаратами; включает в себя модуль расширения дискретных выходов для логического реле и комплект кнопок и ламп.
										</p>
										<p style={{fontSize: '10px', fontWeight: 'bold'}} className="col-md-12">
										№2 - обеспечивает удаленное считывание состояния коммутирующих аппаратов и систем АВР посредством протокола Modbus RTU для нужд систем диспетчеризации; включает в себя коммуникационный модуль расширения для логического реле.
										</p>
										<p style={{fontSize: '10px', fontWeight: 'bold'}} className="col-md-12">
										№3 - обеспечивает визуальное отображение состояния коммутирующих аппаратов, ведение архивов отказов и переключений, дистанционное управление коммутирующими аппаратами в ручном режиме; включает в себя графическую панель оператора.
										</p>
										<p style={{fontSize: '10px', fontWeight: 'bold'}} className="col-md-12">
										№4 - дает возможность переключения коммутирующих аппаратов и работы логического реле при отключении обоих вводов; включает в себя источник бесперебойного питания.
										</p>
										<p style={{fontSize: '10px', fontWeight: 'bold'}} className="col-md-12">
										№5 - включает в себя опцию №1 и обеспечивает удаленную диспетчеризацию с использованием дискретных выходов типа "сухой контакт"
										</p>
									</div>
								</React.Fragment>}

							</div>
						}
						{this.state.page === 'start' && this.state.action=== 'analog' &&
							<div>
								<div className="row form-group">
									<div className='container-fluid form-group'>
										<div
											onClick={this.equipmentChosen}
											style={{background: firstLableStyle,color: firstTextStyle, cursor:'pointer',height:'40px', paddingTop:'5px', fontSize: '16px', boxShadow: shadowStlFirst}}
											className=' col-md-6 text-nowrap text-center'>Конфигуратор подбора оборудования</div>
										<div
											onClick={this.analogChosen}
											style={{background: secondLableStyle, color: secondTextStyle, cursor:'pointer',height:'40px', paddingTop:'5px', fontSize: '16px', boxShadow: shadowStlSecond}}
											className='col-md-6 text-nowrap text-center'>Подбор аналогов сторонних производителей</div>
									</div>
									<div className='container-fluid'>
										<span
											onClick={this.handSearchChosen}
											style={{background: firstLStyle,color: firstTStyle, cursor:'pointer',height:'30px', paddingTop:'3px',marginBottom:'10px',boxShadow: shadowStyleFirst}}
											className='col-md-6 text-nowrap text-center'>Искать вручную</span>
										<span
											onClick={this.listSearchChosen}
											style={{background: secondLStyle, color: secondTStyle, cursor:'pointer',height:'30px', paddingTop:'3px',marginBottom:'10px', boxShadow: shadowStyleSecond}}
											className='col-md-6 text-nowrap text-center'>Загрузить список</span>
									</div>

									{ this.state.searchTab === 'handSearch' &&
										<div id='handSearch' className='container-fluid form-group tab-pane active'>
											<div className='col-md-6 form-group'>
												<label htmlFor="brand">Производитель</label>
												<select className='form-control' name="Все" id="brand" style={{borderRadius: '0px'}}
																onChange={e => this.analogBrandSearch(e.target.value)}>
													<option value="Все">Все</option>
													{this.state.brandCollection.map(item =>
														<option key={item} value={item}>{item}</option>)
													}
												</select>
											</div>
											<div className='col-md-6	 form-group'>
												<label htmlFor="article">Введите артикул или наименование</label>
												<input className='form-control' type="text" id="article" style={{borderRadius: '0px'}}
															 onChange={e => {
																 this.analogSearchHandle(e.target.value)
															 }}/>
											</div>
										</div>
									}
									{this.state.searchTab === 'listSearch' &&
										<div className='container-fluid form-group' >
												<label htmlFor="article">Введите список артикулов через пробел</label>
												<input className='form-control' type="text"  id="article" style={{borderRadius: '0px'}}
																														onChange={e => {
																															this.analogListSearchHandle(e.target.value)
																														}}/>
										</div>
									}
								</div>
							<div className={styles.itemsTableWrapAnalog}>
							<table className={styles.itemsTable}>
							<thead>
							<tr>
								<th colSpan='3'>Устройства других производителей</th>
							</tr>
							<tr>
							<th style={{top:'28px'}}>Артикул</th>
								<th style={{top:'28px'}}>Бренд</th>
							<th style={{top:'28px'}}>Наименование</th>
							</tr>
							</thead>
							<tbody>
						{ this.state.analogItems.map(item =>
							<tr key={item.article} style={{cursor:'pointer'}} >
								<td className="col-md-3 text-nowrap" onClick={()=>this.addAnalogOni(item.analog_article)}>{item.article}</td>
								<td onClick={()=>this.addAnalogOni(item.analog_article)}>{item.brand}</td>
								<td onClick={()=>this.addAnalogOni(item.analog_article)} style={{borderLeft: " 6px solid #29318c"}}>{item.name}</td>
							</tr>)
						}
							</tbody>
							</table>
							</div>
								<div className={styles.itemsTableWrapAnalogList}>
									<table className={styles.itemsTable}>
										<thead>
										<tr>
											<th colSpan='4'>Аналог от ONI</th>
										</tr>
										<tr>
											<th style={{top:'28px'}}>Артикул</th>
											<th style={{top:'28px'}}>Наименование</th>
											<th style={{top:'28px'}}>&nbsp;</th>
											<th style={{top:'28px'}}>&nbsp;</th>
										</tr>
										</thead>
										<tbody>
										{this.state.analogOniItems.map(item =>
											<tr key={item.article}>
												<td className="col-md-3 text-nowrap">{item.article}</td>
												<td>{item.name}</td>
												<td><span className={styles.itemInfo} onClick={() => this.showInfo(item)}><span className="glyphicon glyphicon-info-sign" /></span></td>
												<td className={styles.itemAddToCartBtn}>
														<span className={styles.itemAddToCart} onClick={() => this.onAddToCart(item)}>
															<span className={`glyphicon glyphicon-shopping-cart`} />
														</span>
												</td>
											</tr>
										)}
										</tbody>
									</table>
								</div>
							</div>
						}

						{this.state.page === 'cart' &&
							<MyOrders
								cart={this.state.cart}
								onExport={this.onMyOrdersExport}
								onChangeQuantity={this.onMyOrdersChangeQuantity}
								onDelete={this.onDelete}/>
						}

					</div>

				</div>
			</div>
		);
	}
}

class MyOrders extends React.Component
{
	constructor(props) {
		super(props);

		this.state = {
			contacts: {
				name: '',
				city: '',
				organization: '',
				tel: '',
				email: '',
				comment: '',
				capcha: ''
			},
			requiredFieldsWarn: {
				name: false,
				email: false,
				tel: false
			},
      captchaKey: Date.now()
		};

		this.onSend = this.onSend.bind(this);
		this.onModalSend = this.onModalSend.bind(this);
		this.onUpdateContact = this.onUpdateContact.bind(this);
		this.onExport = this.onExport.bind(this);
		this.handleCaptchaChange 		= this.handleCaptchaChange.bind(this)
		this.onClearModalData 		= this.onClearModalData.bind(this)
	}

	onSend() {
		jQuery(this.modalRef).modal('show');
	}

	onClearModalData() {
      this.setState({
          contacts: {
              name: '',
              city: '',
              organization: '',
              tel: '',
              email: '',
              comment: '',
              capcha: ''
          },
          requiredFieldsWarn: {
              name: false,
              email: false,
              tel: false
          },
					captchaKey: Date.now()
			})
	}

  handleCaptchaChange() {
      this.setState((prevState => {
          const { contacts } = prevState
          contacts.capcha = true
          return contacts
      }))
  }

	onModalSend() {
		const {name, tel, email, capcha} = this.state.contacts
		if (!name || !tel || !email) {
			this.setState({
				requiredFieldsWarn: {
					name: !name,
					tel: !tel,
					email: !email
				}
			})
			return
		}

		if (!capcha) { return }

		jQuery(this.modalRef).modal('hide');

		jQuery.post(
			'itkcfg.php',
			{
				type: 'oni_equipment',
				action: 'postForm',
				data: {
					cart: this.props.cart,
					contacts: this.state.contacts
				}
			}
		);
    this.onClearModalData()
		alert('Благодарим за заказ! Наши сотрудники свяжутся с вами в ближайшее время.');
	}

	onUpdateContact(prop, e) {
		const value = e.target.value;

		this.setState(prevState => {
			const contacts = jQuery.extend({}, prevState.contacts);
			const requiredFieldsWarn = prevState.requiredFieldsWarn
			contacts[prop] = value;
			requiredFieldsWarn[prop] = false
			return {
				contacts,
				requiredFieldsWarn
			};
		});
	}

	onExport(e, format) {
		e.preventDefault();
		this.props.onExport(format);
	}

	render() {
		return (
			<div>
				<h2>Мои заказы</h2>

				<table className={styles.myOrdersItemsTable}>
					<thead>
					<tr>
						<th className="text-center">Артикул</th>
						<th className="text-center">Наименование</th>
						<th className="text-center">Количество</th>
						<th className="text-center">&nbsp;</th>
					</tr>
					</thead>
					<tbody>
					{this.props.cart.map((item, index) =>
						<tr key={index + Date.now()}>
							<td className="col-md-3 text-nowrap">{item.article}</td>
							<td>{item.name}</td>
							<td><input type="number" min="1" className="form-control" defaultValue={item.quantity}
												 onChange={e => this.props.onChangeQuantity(item, e.target.value)} /></td>
							<td style={{cursor:'pointer'}} onClick={() => this.props.onDelete(item)}>&#10006;</td>
						</tr>
					)}
					</tbody>
				</table>
				<div className="row">
					<div className="col-md-6">
						<div className="btn-group">
							<button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown"
											aria-haspopup="true" aria-expanded="false"
											disabled={this.props.cart.length === 0}>Export <span className="caret" /></button>
							<ul className="dropdown-menu">
								<li><a href="#" onClick={e => this.onExport(e, 'pdf')}>PDF</a></li>
								<li><a href="#" onClick={e => this.onExport(e, 'xls')}>Excel</a></li>
								<li><a href="#" onClick={e => this.onExport(e, 'print')}>Печать</a></li>
							</ul>
						</div>
					</div>
					<div className="col-md-6 text-right">
						<button type="button" className="btn btn-primary" disabled={this.props.cart.length === 0}
										onClick={this.onSend}>Отправить заказ в отдел продаж</button>
					</div>
				</div>

				<div className="modal fade" tabIndex="-1" role="dialog" ref={node => this.modalRef = node}>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<button
										type="button"
										className="close"
										data-dismiss="modal"
										aria-label="Close"
                    onClick={this.onClearModalData}
								><span
									aria-hidden="true">&times;</span>
								</button>
								<h4 className="modal-title">Отправить заказ в отдел продаж</h4>
							</div>
							<div className="modal-body">
								<p>Поля, отмеченные звездочкой <span className={styles.red}>*</span>, обязательны для заполнения.</p>

								<form className="form-horizontal">
									<div className="form-group">
										<label htmlFor="inputName" className="col-sm-3 control-label">Имя<span className={styles.red}>*</span></label>
										<div className="col-sm-9">
											<input
                        value={this.state.contacts.name}
												type="text"
												className={`form-control ${this.state.requiredFieldsWarn.name ? styles.inputWarn : ''}`}
												id="inputName"
												onChange={e => this.onUpdateContact('name', e)}
											/>
										</div>
									</div>

									<div className="form-group">
										<label htmlFor="inputCity" className="col-sm-3 control-label">Город</label>
										<div className="col-sm-9">
											<input
                          value={this.state.contacts.city}
													type="text"
													className="form-control"
													id="inputCity"
													onChange={e => this.onUpdateContact('city', e)} />
										</div>
									</div>

									<div className="form-group">
										<label htmlFor="inputOrganization" className="col-sm-3 control-label">Организация</label>
										<div className="col-sm-9">
											<input
                          value={this.state.contacts.organization}
													type="text"
													className="form-control"
													id="inputOrganization"
													onChange={e => this.onUpdateContact('organization', e)} />
										</div>
									</div>

									<div className="form-group">
										<label htmlFor="inputTel" className="col-sm-3 control-label">Тел.<span className={styles.red}>*</span></label>
										<div className="col-sm-9">
											<input
												value={this.state.contacts.tel}
												type="text"
												className={`form-control ${this.state.requiredFieldsWarn.tel ? styles.inputWarn : ''}`}
												id="inputTel"
												onChange={e => this.onUpdateContact('tel', e)}
											/>
										</div>
									</div>

									<div className="form-group">
										<label htmlFor="inputEmail" className="col-sm-3 control-label">Эл. почта<span className={styles.red}>*</span></label>
										<div className="col-sm-9">
											<input
                        value={this.state.contacts.email}
												type="email"
												className={`form-control ${this.state.requiredFieldsWarn.email ? styles.inputWarn : ''}`}
												id="inputEmail"
												onChange={e => this.onUpdateContact('email', e)}
											/>
										</div>
									</div>
									<div className="form-group">
										<label htmlFor="inputComment" className="col-sm-3 control-label">Дополнительные комментарии</label>
										<div className="col-sm-9">
											<textarea
                          value={this.state.contacts.comment}
													cols="40"
													rows="5"
													className="form-control"
													id="inputComment"
													onChange={e => this.onUpdateContact('comment', e)} />
										</div>
									</div>
									<div className="form-group">
										<div className="col-sm-3 " />
										<div className="col-sm-9">
											<ReCAPTCHA
                        key={this.state.captchaKey}
												sitekey="6LdKrlcpAAAAAE7Tt1P-7EwdxvZrw9ewmxSj6xvM"
												onChange={this.handleCaptchaChange}
											/>
										</div>
									</div>
								</form>
							</div>
							<div className="modal-footer">
								<button
										type="button"
										className="btn btn-default"
										data-dismiss="modal"
                    onClick={this.onClearModalData}
								>Закрыть</button>
								<button
									type="button"
									className="btn btn-primary"
									onClick={this.onModalSend}
									disabled={
										!(this.state.contacts.name
										&& this.state.contacts.tel
										&& this.state.contacts.email
										&& this.state.contacts.capcha)
									}
								>Отправить</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const FILTER_SORT = {
	oni_equipment_pch: ['app', 'power', 'vin', 'phase_in', 'amperage', 'brake_key'],
	oni_equipment_relay: ['type', 'voltage', 'contact_type', 'input_voltage', 'load_voltage', 'phases', 'switch_current', 'for_relay_type'],
	oni_equipment_dampactuator: ['voltage', 'torque', 'control_type', 'implementation'],
	oni_equipment_pressuresensor: ['out_signal_type', 'conn_type', 'measurement_accuracy', 'pressure_type', 'pressure_range'],
	oni_equipment_tempsensor: ['good_type', 'sensor_type', 'elem_type', 'length', 'work_temp'],
	oni_equipment_pid: ['series', 'size', 'out1', 'out2', 'crash', 'retransmission', 'input', 'link', 'protection', 'power'],
	oni_equipment_reserve:['groups', 'power_sources', 'apply_options', 'voltage', 'grouping', 'auto_switch'],
	oni_equipment_pumping:['number_pumps', 'start_type', 'power', 'nominal_voltage', 'type_application', 'number_sensors','option'],
	oni_equipment_power:['output_voltage', 'capacity', 'amperage', 'output_relay', 'remote_setting'],
	oni_equipment_starter:['nominal_voltage', 'power', 'amperage', 'control_voltage', 'modbus', 'start_button', 'phases'],
};

const FILTER_TOP = {
	oni_equipment_controller: ['family'],
	oni_equipment_hmi: ['family'],
	oni_equipment_pressuresensor: ['out_signal_type'],
	oni_equipment_tempsensor: ['good_type']
};

const FILTER_CHECKBOX = ['display', 'sd', 'ethernet', 'rs232', 'rs485', 'ext','grouping', 'auto_switch', 'option', 'output_relay', 'remote_setting'];

class CommonArticle extends React.Component
{
	part(filterName, pattern) {
		const fv = this.props.filter[filterName];
		const cn = fv ? styles.commonArticleHighlight : null;
		const m = this.props.map[filterName];
		return <span className={cn}>{fv && m && m[fv] ? m[fv] : pattern}</span>;
	}

	render() {
		return (
			<span className="h4">
				<span className={styles.commonArticle}>
					{this.part('series', 'АА')}
					1
					{this.part('size', 'ХХХ')}
					-
					{this.part('out1', 'Х')}
					{this.part('out2', 'Х')}
					{this.part('crash', 'Х')}
					-
					{this.part('retransmission', 'Х')}
					{this.part('input', 'Х')}
					0-
					{this.part('link', 'Х')}
					{this.part('protection', 'Х')}
					{this.part('power', 'ХХ')}
				</span>
			</span>);
	}
}

class StarterArticle extends React.Component
{
	part(filterName, pattern) {
		const fv = this.props.filter[filterName];
		const cn = fv ? styles.commonArticleHighlight : null;
		const m = this.props.map[filterName];
		return <span className={cn}>{fv && m && m[fv] ? m[fv] : pattern}</span>;
	}

	render() {
		return (
			<span className="h4">
				<span className={styles.commonArticle}>
					SFB-
					{this.part('nominal_voltage', 'XX')}
					-
					{this.part('power', 'ХХ')}
					-
					{this.part('control_voltage', 'Х')}
					-
					{this.part('modbus', 'Х')}
					{this.part('start_button', 'Х')}
				</span>
			</span>);
	}
}


class PumpingArticle extends React.Component
{
	part(filterName, pattern) {
		const fv = this.props.filter[filterName];
		const cn = fv ? styles.commonArticleHighlight : null;
		const m = this.props.map[filterName];
		return <span className={cn}>{fv && m && m[fv] ? m[fv] : pattern}</span>;
	}

	render() {
		return (
			<span className="h4">
				<span className={styles.commonArticle}>
					КНС-
					{this.part('number_pumps', 'X')}
					-
					{this.part('power', 'ХХ')}
					-
					{this.part('nominal_voltage', 'ХXX')}
					-
					{this.part('start_type', 'ХX')}
					-
					{this.part('type_application', 'Х')}
					{this.part('number_sensors', 'Х')}
				</span>
			</span>);
	}
}


class Filter extends React.Component
{
	constructor(props) {
		super(props);

		this.state = {
			showMore: false
		};
	}


	render() {
		let maxMainFilters = 6;

		if ('filter_show_more' in this.props.state.equipmentTypeObj
			&& this.props.state.equipmentTypeObj.filter_show_more === false)
		{
			maxMainFilters = 100;
		}

		const filterTop = this.props.state.equipmentType in FILTER_TOP ?
			FILTER_TOP[this.props.state.equipmentType] : [];

		let filterHide = [];

		if (this.props.state.equipmentType === 'oni_equipment_relay')
		{
			if (this.props.state.currentFilter.type && this.props.state.currentFilter.type !== 'Розетки (колодки)')
			{
				filterHide.push('for_relay_type');
			}
		}

		// исключение фильтров
		const exclusion = ['groups_name', 'article_group', 'count_equipment', 'link_spec']

		const filters = Object.keys(this.props.state.filters)
			.filter(filter => [...FILTER_CHECKBOX, ...filterTop, ...filterHide, ...exclusion].indexOf(filter) === -1)
			.sort();

		const filterSort = this.props.state.equipmentType in FILTER_SORT ?
			FILTER_SORT[this.props.state.equipmentType] : null;

		if (filterSort)
		{
			filters.sort((a, b) => {
				if (filterSort.indexOf(a) > -1 && filterSort.indexOf(b) > -1)
				{
					return (filterSort.indexOf(a) - filterSort.indexOf(b));
				}
				else if (filterSort.indexOf(a) === -1 && filterSort.indexOf(b) > -1)
				{
					return 1;
				}
				else if (filterSort.indexOf(a) > -1 && filterSort.indexOf(b) === -1)
				{
					return -1;
				}

				return 0;
			});
		}

		return (
			<div>

				{this.props.state.equipmentType === 'oni_equipment_pid'
				&& <div className="row form-group">
					<div className="col-md-12">
						<CommonArticle filter={this.props.state.currentFilter} map={this.props.state.filter_common_article} />
						{this.props.state.items.length === 1 && <span>{this.props.state.items[0].name}</span>}
					</div>
				</div>}

				{this.props.state.equipmentType === 'oni_equipment_starter'
				&& <div className="row form-group">
					<div className="col-md-12">
						<StarterArticle filter={this.props.state.currentFilter} map={this.props.state.filter_starter_article} />
						{this.props.state.items.length === 1 && <span>{this.props.state.items[0].name}</span>}
					</div>
				</div>}

				{this.props.state.equipmentType === 'oni_equipment_pumping'
				&& <React.Fragment>
					<div className="row form-group">
						<div className="col-md-12">
							<PumpingArticle filter={this.props.state.currentFilter} map={this.props.state.filter_pumping_article} />
							{this.props.state.items.length === 1 && <span>{this.props.state.items[0].name}</span>}
						</div>
					</div>
					<div style={{position: 'absolute', top: '290px', left: '410px', color: '#29318C', fontSize: '12px'}}>
						<span className='glyphicon glyphicon-info-sign' style={{fontSize: '14px', top:'3px'}}/>
						 – в этом разделе можно экспортировать в Excel или на печать Спецификацию выбранного решения, а также скачать схемы компоновки и типовых решений
					</div>
				</React.Fragment>}


				{filterTop.map(topFilter =>
					<div className="row form-group" key={topFilter}>
							<div className="col-md-2">
								<div style={{padding: "4px 0"}}>{this.props.state.filters_names[topFilter]}</div>
							</div>

							<div className="col-md-10">
								<select className="col-md-5"
												value={this.props.state.currentFilter[topFilter] ? this.props.state.currentFilter[topFilter] : ''}
												onChange={e => this.props.onFilter(topFilter, e.target.value)}>
									<option value="">Все</option>

									{this.props.state.filters[topFilter].map(value =>
										<option key={value} value={value}>{value}</option>
									)}
								</select>
							</div>
						</div>
				)}

				<div className="row">
					{filters.map((filter, filterIndex) =>
						filterIndex < maxMainFilters &&
						<div key={filter} className="col-md-6 form-group">
							<div className="row">
								<label className="col-md-12 text-nowrap">
									{this.props.state.filters_names[filter]}<br/>
									<select
										className="col-md-12"
										value={this.props.state.currentFilter[filter] ? this.props.state.currentFilter[filter] : ''}
										onChange={e => this.props.onFilter(filter, e.target.value)}>
										<option value="">{filter === 'apply_options' ? 'Без опций':'Все'}</option>
										{this.props.state.filters[filter].map(filterValue =>
											filterValue ? <option key={filterValue} value={filterValue}>{filterValue}</option> : null
										)}
									</select>
								</label>
							</div>
						</div>
					)}
				</div>

				{filters.length > maxMainFilters &&
					<div className="row">
						<div className={`${styles.filtersShowMore} col-md-12 form-group`}>
							<span onClick={() => this.setState(prevState => ({showMore: !prevState.showMore}))}>Показать больше фильтров {this.state.showMore ? <span>&#9660;</span> : <span>&#9650;</span>}</span>
						</div>

						{this.state.showMore && filters.map((filter, filterIndex) =>
							filterIndex >= maxMainFilters &&
							<div key={filter} className="col-md-6 form-group">
								<div className="row">
									<label className="col-md-12 text-nowrap">
										{this.props.state.filters_names[filter]}<br/>
										<select className="col-md-12" value={filter in this.props.state.currentFilter ? this.props.state.currentFilter[filter] : ''} onChange={e => this.props.onFilter(filter, e.target.value)}>
											<option value="">Все</option>
											{this.props.state.filters[filter].map(filterValue =>
												<option key={filterValue} value={filterValue}>{filterValue}</option>
											)}
										</select>
									</label>
								</div>
							</div>
						)}
					</div>
				}

				<div className="row">
					{FILTER_CHECKBOX.map(prop => prop in this.props.state.filters && this.props.state.filters[prop].indexOf('Да') !== -1 &&
						<div key={prop} className={prop === 'grouping' || prop === 'auto_switch' ? "col-md-6" :"col-md-3"}>
							<label>
								<input
									style={{margin: '4px 5px 0 0'}}
									type="checkbox"
									checked={prop in this.props.state.currentFilter && this.props.state.currentFilter[prop] === 'Да'}
									onChange={e => this.props.onFilter(prop, e.target.checked ? 'Да' : '')}
								/>
								{this.props.state.filters_names[prop]}
							</label>
						</div>
					)}
				</div>

				<div className="row">
					<div className="col-md-12">
						<button type="button" className="btn btn-default btn-xs" onClick={this.props.onReset}>Сбросить все фильтры</button>
					</div>
				</div>

			</div>
		);
	}
}

class ProductInfo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			item: null,
			info: ''
		};

		this.onInfoChange = this.onInfoChange.bind(this);
		this.onExport = this.onExport.bind(this);
	}

	componentDidMount() {
		if(this.props.equipmentType === 'oni_equipment_reserve') {
			this.setState({item: this.props.item})
			return
		}
		if(this.props.equipmentType === 'oni_equipment_pumping') {
			const item = {...this.props.item}
			item.LayoutDiagram = [{
				name: this.props.item.name,
				file_ref:{
					uri: `itkcfg.php?action=getFileZip&type=oni_equipment&name=pumping&article=${this.props.item.article}`
				}
			}]

			const type = this.props.item.type_application === 'Поплавковые' ? 'Float' : 'Conductometric'

			item.AlbumSolutions = [{
				name: this.props.item.name,
				file_ref:{
					uri: `itkcfg.php?action=getFileZip&type=oni_equipment&name=AlbumSolutions&article=${type}PDF`
				}
			},
				{
					name: this.props.item.name,
					file_ref:{
						uri: `itkcfg.php?action=getFileZip&type=oni_equipment&name=AlbumSolutions&article=${type}DWG`
					}
				}]

			this.setState({item: item})
			return
		}

		jQuery.getJSON(
			'itkcfg.php',
			{
				type: 'oni_equipment',
				action: 'getItem',
				article: this.props.item.article
			},
			items => {
				this.setState({
					item: items.length === 0 ? false : items[0]
				});
			}
		);
	}

	onInfoChange(e) {
		this.setState({
			info: e.target.value
		});
	}

	onExport(e, format) {
		e.preventDefault();
		this.props.onExport(this.state.item, format);
	}

	render() {
		if (this.state.item === null) {
			return <div>Загрузка...</div>;
		}

		const infoTypes = [
			{ type: 'Passport', name: 'Паспорта' },
			{ type: 'Certificates', name: 'Сертификаты' },
			{ type: 'Software', name: 'Программное обеспечение' },
			{ type: 'WiringDiagram', name: 'Схема подключения' },
			{ type: 'LayoutDiagram', name: 'Схема компоновки в PDF' },
			{ type: 'InstallationProduct', name: 'Информация о монтаже' },
			{ type: 'EquipmentForSAPR', name: 'Модели для программ проектирования' },
			{ type: 'DimensionDrawing', name: 'Габаритные чертежи' },
			{ type: 'AlbumSolutions', name: 'Альбом решений' },

		];

		const step = (this.state.item.EquipmentForSAPR && this.state.item.EquipmentForSAPR.length > 0)
			? this.state.item.EquipmentForSAPR.filter(eq => eq.pubName === 'STEP-формат') : null;

		return (
			<div>
				<div className="form-group">
					<div><strong>{this.props.item.article}</strong></div>
					<div>{this.props.item.name}</div>
				</div>

				<div className="form-group">
					<div className="row">
						<div className="col-md-2">
							<strong>Информация</strong>
						</div>
						<div className="col-md-10">
							<select onChange={this.onInfoChange}>
								<option value="">Общая информация</option>
								{this.state.item !== false && infoTypes.map(infoType =>
									infoType.type in this.state.item && <option key={infoType.type} value={infoType.type}>{infoType.name}
								</option>
								)};
							</select>
						</div>
					</div>
				</div>

				{ <div className={`row form-group ${styles.productInfoBlock}`}>
					{this.state.item === false ? (
						<div>К сожалению, на текущий момент информации о продукте нет.</div>
					) :
						(() => {
							switch (this.state.info) {
								case 'Passport':
								case 'Certificates':
								case 'EquipmentForSAPR':
									return (
										<div>
											{this.state.item[this.state.info].map((item, i) =>
												item.pubName &&
												<div key={this.state.info + i}>
													<a href={item.file_ref.uri} target="_blank" rel="noreferrer noopener">{item.pubName ? item.pubName : item.type}</a>
												</div>
											)}
										</div>
									);

								case 'Software':
									return (
										<div>
											{this.state.item.Software.map((software, i) =>
												<div key={i}>
													<a href={software.file_ref.uri} target="_blank" rel="noreferrer noopener">{software.file_ref.baseName}</a>
												</div>
											)}
										</div>
									);

								case 'WiringDiagram':
									return (
										<div>
											{this.state.item.WiringDiagram.map((wd, i) =>
												<div key={i}>
													<a href={wd.file_ref.uri} target="_blank" rel="noreferrer noopener">Схема подключения</a>
												</div>
											)}
										</div>
									);

								case 'LayoutDiagram':
									return (
										<div>
											{this.state.item.LayoutDiagram.map((wd, i) =>
												<div key={i}>
													<a href={wd.file_ref.uri} target="_blank" rel="noreferrer noopener">Схема компоновки в PDF</a>
												</div>
											)}
										</div>
									);

								case 'AlbumSolutions':
									return (
										<div>
											{this.state.item.AlbumSolutions.map((wd, i) =>
												<div key={i}>
													<a href={wd.file_ref.uri} target="_blank" rel="noreferrer noopener">
														Схема компоновки в {i === 0 ? 'PDF' : 'DWG'}
													</a>
												</div>
											)}
										</div>
									);


								case 'InstallationProduct':
									return (
										<div>
											{this.state.item.InstallationProduct.map((item, i) =>
												<div key={i}>
													<a href={item.file_ref.uri} target="_blank" rel="noreferrer noopener">{item.type}</a>
												</div>
											)}
										</div>
									);

								case 'DimensionDrawing':
									return (
										<div>
											{this.state.item.DimensionDrawing.map((item, i) =>
												<div key={i}>
													<a href={item.file_ref.uri} target="_blank" rel="noreferrer noopener">Габаритный чертеж</a>
												</div>
											)}
										</div>
									);

								default:
									if(this.props.equipmentType === 'oni_equipment_reserve' || this.props.equipmentType === 'oni_equipment_pumping') {
										return (
											<div className="form-group">
												<table className={styles.myOrdersItemsTable}>
													<thead>
													<tr>
														<th className="text-center">Артикул</th>
														<th className="text-center">Наименование</th>
														<th className="text-center">Количество</th>
														<th className="text-center">{this.props.equipmentType === 'oni_equipment_reserve' ? 'Примечание' : 'Производитель'}</th>
													</tr>
													</thead>
													<tbody>
													{this.props.item.printList.map((item, index) =>
														<tr key={index}>
															<td className="col-md-3 text-nowrap">{item.article}</td>
															<td>{item.name}</td>
															<td  style={{textAlign: 'center'}}>{item.count_equipment}</td>
															<td>{item.apply_options ? item.apply_options : item.provider}</td>
														</tr>
													)}
													</tbody>
												</table>
											</div>
										)
									}

									return (
										<div>
											<div className="col-md-3">
												{this.state.item.ImgJpeg && this.state.item.ImgJpeg.length > 0 &&
													<img src={this.state.item.ImgJpeg[0].file_ref.uri} style={{maxWidth: '100%'}} alt="" />
												}
											</div>
											<div className="col-md-9" style={{whiteSpace: 'pre-line'}}>
												{this.state.item.Description && this.state.item.Description.length > 0 ? this.state.item.Description[0].desc_ru : null}
											</div>
										</div>
									);
							}
						})()
					}
				</div>}



				<div className="row">
					<div className="col-md-6 form-group">
						<button type="button" className="btn btn-primary btn-block" onClick={() =>this.props.onAddToCart(this.props.item)}>Добавить в мои заказы</button>
					</div>

						{step && step.length > 0 && step[0].file_ref ?
							<div className="col-md-6 form-group">
								<a className="btn btn-default btn-block" href={step[0].file_ref.uri} target="_blank" rel="noreferrer noopener">Скачать STEP</a>
							</div>
							: false
								// <button type="button" className="btn btn-default btn-block" disabled>Скачать STEP</button>
						}

					{/*<div className="col-md-6 form-group">*/}
					{/*	<a className="btn btn-primary btn-block" href={`http://oni-system.com/produktsiya/catalog/?page=detail&article=${this.props.item.article}`} target="_blank" rel="noopener noreferrer">Перейти в каталог</a>*/}
					{/*</div>*/}
					<div className="col-md-6 form-group">
						<div className="row">
							<div className="col-md-12 btn-group">
								<button type="button" className="btn btn-default btn-block dropdown-toggle" data-toggle="dropdown"
												aria-haspopup="true" aria-expanded="false">Export <span className="caret" /></button>
								<ul className="dropdown-menu">
									<li><a href="#" onClick={e => this.onExport(e, 'pdf')}>PDF</a></li>
									<li><a href="#" onClick={e => this.onExport(e, 'print')}>Печать</a></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default OniEquipmentConfigurator;



// WEBPACK FOOTER //
// ./src/react/OniEquipmentConfigurator.jsx